import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, Input, inject } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { Router } from '@angular/router';
import { NgSelectModule } from '@ng-select/ng-select';
import { EditTrackerService } from '../../../../../../core/services/edit-tracker.service';
import { PermissionService } from '../../../../../../core/services/permission';
import { Customer } from '../../../../../../data/models';
import { BreezeCase } from '../../../../../../utils/types/convert-case';
import { LayoutService } from '../../../../layout.service';
import { MenubarCollapseComponent } from '../../menubar-collapse/menubar-collapse.component';
import { MenuName } from '../../menubar-scroll/menubar-menu-type.model';
import { NavMenuItem } from '../../menubar/domain/entities/menu-item.model';
import { MenubarComponent } from '../../menubar/menubar.component';
import { SecondaryNavService } from '../../secondary-nav.service';
import { SecondaryNavStoreService } from '../../secondary-nav.store.service';
import { TopbarInfoComponent } from '../../topbar-info/topbar-info.component';
import { TopbarInfo } from '../../topbar-info/topbar-info.model';
import { TopnavComponent } from '../../topnav/topnav.component';
import { SecondaryNavClientService } from '../secondary-nav-client.service';
import { MenubarScrollComponent } from './../../menubar-scroll/menubar-scroll.component';

@Component({
    selector: 'app-secondary-nav-clients',
    templateUrl: './secondary-nav-clients.component.html',
    styleUrls: ['./secondary-nav-clients.component.scss', '../../secondary-nav.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [
        CommonModule,
        MenubarCollapseComponent,
        MenubarComponent,
        TopnavComponent,
        TopbarInfoComponent,
        NgSelectModule,
        FormsModule,
        MenubarScrollComponent,
    ],
})
export class SecondaryNavClientsComponent {
    @Input() clientIn!: BreezeCase<Customer>;
    #navState = inject(SecondaryNavStoreService);
    #secondaryNavClientService = inject(SecondaryNavClientService);
    #permissionService = inject(PermissionService);
    #layoutService = inject(LayoutService);
    #editTrackerService = inject(EditTrackerService);
    #navService = inject(SecondaryNavService);
    #router = inject(Router);

    isTracking$ = this.#editTrackerService.isTracking$;
    menuName = MenuName;
    isMobile$ = this.#layoutService.isMobile$;
    collapsed$ = this.#navState.navCollapsed.obs$;
    canEditCustomerType$ = this.#permissionService.getState('customers.maintain-customers.edit-customer-type');

    clientMenuItems?: NavMenuItem[];
    clientInfo?: TopbarInfo;
    client$ = this.#navState.currentClient.obs$;
    clientTypes$ = this.#secondaryNavClientService.getCustomerTypes();

    ngOnInit() {
        if (!this.clientIn) throw new TypeError('Client is required');

        this.#navState.currentClient.set(this.clientIn);
        this.#navService.setCollapsedInitialState();
        this.clientMenuItems = this.#secondaryNavClientService.getMenuBarData();
    }

    setType(group: string) {
        const client = this.#navState.currentClient.value();
        if (client) {
            client.ContactGroup = group;
            this.#secondaryNavClientService.saveClient(client);
        }
    }

    back() {
        this.#router.navigate(['/customers', 'list'], { queryParams: { subpanel: true } });
    }

    ngOnDestroy() {
        this.#navState.clearClient();
    }
}
